<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-company-department" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <v-form v-model="valid" ref="form">
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col">
                                            <v-text-field bg-color="white"
                                                          :rules="[rules.required]"
                                                          name="CompanyName"
                                                          id="CompanyName"
                                                          type="text"
                                                          label="Företagsnamn"
                                                          variant="outlined"
                                                          v-model="company.Name"
                                                          focused="true"></v-text-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">

                                            <v-select name="Status" v-model="company.IntStatus" id="Status" item-title="name" item-value="val" :items="statuses" label="Status">

                                            </v-select>

                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <v-select name="WorkSpace" v-model="company.WorkspaceId" item-title="WorkspaceName" item-value="WorkspaceId" :items="workspaces" label="Arbetsplats">

                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <v-select name="UserId" v-model="company.UserId" item-title="Username" item-value="UserId" :items="users" label="Användare">

                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </v-form>

                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getCurrentInstance } from 'vue'
    import ValidationService from "../../../Services/ValidationService";
    import AdminService from "../../../Services/AdminService";
    import { ref } from 'vue'
    const form = ref(null);

    export default {
        emits: ['updated'],
        name: 'update-company-department',
        props: {
            clubid: String,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async open(company) {
                this.company = company;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            async loadWorkspaces() {
                this.workspaces = await AdminService.getWorkspaceFromCurrentDepartment();
            },
            async loadUsers() {
                this.users = await AdminService.getWorkspaceUsers();
            },
            async save() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                await AdminService.updateCompany(this.company);
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");
            },
            reset() {
                this.company = {
                    DepartmentId: 0,
                    ClubId: 0,
                    WorkspaceId: 0,
                    Name:''
                };
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                thisModal: {},
                company: {
                    DepartmentId: 0,
                    ClubId: 0,
                    WorkspaceId: 0,
                    Name:'',
                },
                workspaces: [],
                statuses: [{ name: 'Aktiv', val: 10 }, { name: 'Privat', val: 15 }, { name: 'Dold', val: 20 }]
            };
        },
        watch: {
        },
        mounted() {
            this.loadWorkspaces();
            this.loadUsers();

            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

        },
        setup() {
            return { form }
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
